"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeMappingMenu = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const hooks_1 = require("../../client/hooks");
const utils_1 = require("../../utils/utils");
const table_styles_1 = require("../table.styles");
const attributes_1 = require("../../../client/attributes");
const values_1 = require("../../../client/values");
const context_1 = require("../../../context");
const query_params_1 = require("../../../hooks/query-params");
const hooks_2 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const router_1 = require("../../../../router");
const store_1 = require("../../../../store");
const VALUE_CELLS = [utils_1.CellType.AttributeValueCell, utils_1.CellType.RegularCell];
const HEADER_CELLS = [utils_1.CellType.AttributeHeaderCell, utils_1.CellType.AttributeValueCell];
const AttributeMappingMenu = ({ x, y, isMapped: initialIsMapped, title, value, cellType, onClose, onMappingChange, selectedStrategyNodeId, selectedAttributeName, displayedProductTitles, colId, }) => {
    const [isMapped, setIsMapped] = react_1.default.useState(initialIsMapped);
    const { isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const { addAttributesToSeveralNodes } = (0, attributes_1.useAddAttributesToNode)();
    const { addValuesToSeveralNodes } = (0, values_1.useAddValuesToSeveralNodes)();
    const { deleteAttributesFromSeveralNodes } = (0, attributes_1.useDeleteAttributesFromSeveralNodes)();
    const { deleteValuesFromSeveralNodes } = (0, values_1.useDeleteValuesFromSeveralNodes)();
    const { addSuccess, addError } = (0, hooks_2.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { getSearchParamsString } = (0, query_params_1.useSearchParamsString)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedProjectId = (0, store_1.useSelectedProjectId)();
    const { loadAttributionInfo } = (0, hooks_1.useGetAttributeValueByName)({ productTreeNodeId: selectedStrategyNodeId });
    const menuRef = react_1.default.useRef(null);
    (0, react_1.useEffect)(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);
    const handleAddItemsToHistory = (attributes, treeNodePaths) => {
        const historyItems = [];
        for (const treeNodePath of treeNodePaths) {
            for (const attribute of attributes) {
                const { values, name } = attribute;
                historyItems.push({
                    id: name,
                    entityType: store_1.ChangeEntityType.Attribute,
                    actionType: store_1.ChangeActionType.Add,
                    path: treeNodePath,
                });
                for (const valueItem of values) {
                    const historyItem = {
                        id: `${name}${store_1.LABEL_VALUE_PAIR_SEPARATOR}${valueItem.name}`,
                        entityType: store_1.ChangeEntityType.Value,
                        actionType: store_1.ChangeActionType.Add,
                        path: treeNodePath,
                    };
                    historyItems.push(historyItem);
                }
            }
        }
        dispatch((0, store_1.enrichAIAddChanges)(selectedCatalogId, historyItems));
    };
    const handleDeleteItemsFromHistory = (ids, treeNodePaths, entityType) => {
        const historyItems = [];
        for (const id of ids) {
            for (const treeNodePath of treeNodePaths) {
                historyItems.push({
                    id,
                    entityType,
                    actionType: store_1.ChangeActionType.Delete,
                    path: treeNodePath,
                });
            }
        }
        dispatch((0, store_1.enrichAIAddChanges)(selectedCatalogId, historyItems));
    };
    const updateCellMappings = (isMapped, cellInfo) => {
        if (!displayedProductTitles || displayedProductTitles.length === 0) {
            console.error('No displayed product titles available for mapping update');
            return;
        }
        const entityName = VALUE_CELLS.includes(cellType) ? value : selectedAttributeName;
        if (HEADER_CELLS.includes(cellType)) {
            // For header cells, update mapping for all columns
            displayedProductTitles.forEach((pt) => {
                if (pt.title) {
                    const columnCellInfo = cellInfo ? {
                        nodeId: pt.id,
                        title: pt.title,
                        value: cellInfo.value || value,
                        attribute: cellInfo.attribute,
                        parentTitle: pt.parentTitle || '',
                        parentId: '',
                    } : undefined;
                    onMappingChange(`${entityName}||${pt.title}`, isMapped, columnCellInfo);
                }
            });
            return;
        }
        // For regular cells, update mapping for single column
        if (!title) {
            console.error('Missing title for single cell mapping update');
            return;
        }
        onMappingChange(`${entityName}||${title}`, isMapped, cellInfo);
    };
    const handleMap = (attributeName, valueName, selectedNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const request = VALUE_CELLS.includes(cellType) ? addValuesToSeveralNodes : addAttributesToSeveralNodes;
        try {
            // TODO: Change the condition. Do not pass the value if it's not selected
            const selectedValueName = valueName !== attributeName ? valueName : null;
            const attributionInfo = yield loadAttributionInfo(attributeName, selectedValueName);
            if (!attributionInfo) {
                return;
            }
            const { label, labelDescription, value, valueDescription, } = attributionInfo;
            const attributeData = {
                name: label,
                description: labelDescription !== null && labelDescription !== void 0 ? labelDescription : '',
                values: value ? [{ name: value, description: valueDescription }] : [],
            };
            const updatedPaths = yield request([attributeData], selectedNodeIds);
            handleAddItemsToHistory([attributeData], updatedPaths);
            setIsMapped(true);
            updateCellMappings(true, {
                nodeId: colId,
                title,
                attribute: label,
                value,
                parentTitle: ((_a = displayedProductTitles.find((pt) => pt.title === title)) === null || _a === void 0 ? void 0 : _a.parentTitle) || '',
                parentId: '',
            });
            addSuccess(t({ key: 'ATTRIBUTE_MAPPED_SUCCESS' }));
            onClose();
        }
        catch (error) {
            addError(t({ key: 'ATTRIBUTE_MAPPING_ERROR' }), error.message);
        }
    });
    const handleUnmap = (attributeName, value, selectedNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        const isValueCellType = VALUE_CELLS.includes(cellType);
        const promise = isValueCellType
            ? () => deleteValuesFromSeveralNodes(attributeName, [value], selectedNodeIds)
            : () => deleteAttributesFromSeveralNodes([attributeName], selectedNodeIds);
        try {
            const updatedPaths = yield promise();
            const updatedEntityType = isValueCellType ? store_1.ChangeEntityType.Value : store_1.ChangeEntityType.Attribute;
            const historyIds = isValueCellType ? [`${attributeName}${store_1.LABEL_VALUE_PAIR_SEPARATOR}${value}`] : [attributeName];
            handleDeleteItemsFromHistory(historyIds, updatedPaths, updatedEntityType);
            setIsMapped(false);
            updateCellMappings(false);
            addSuccess(t({ key: 'ATTRIBUTE_UNMAPPED_SUCCESS' }));
            onClose();
        }
        catch (error) {
            addError(t({ key: 'ATTRIBUTE_MAPPING_ERROR' }), error.message);
        }
    });
    const handleMappingChange = (e) => {
        e.stopPropagation();
        const newIsMapped = e.target.checked;
        const relatedNodes = HEADER_CELLS.includes(cellType)
            ? displayedProductTitles.map((pt) => pt.id)
            : [colId];
        if (newIsMapped) {
            void handleMap(selectedAttributeName, value, relatedNodes);
        }
        else {
            void handleUnmap(selectedAttributeName, value, relatedNodes);
        }
    };
    // Get the URL for the matrix view with query parameters
    const getMatrixUrl = () => {
        const newSearchParams = {
            projectId: selectedProjectId,
            catalogId: selectedCatalogId,
            terminalNodeId: colId,
            attributeName: selectedAttributeName,
            value,
        };
        const serializedSearchParams = getSearchParamsString(newSearchParams);
        return `/${router_1.ENRICH}/${router_1.EnrichSection.EnrichAI}/${router_1.EnrichSection.Workspace}${serializedSearchParams}`;
    };
    return (react_1.default.createElement(table_styles_1.ContextMenuContainer, { ref: menuRef, x: x, y: y, role: "menu", tabIndex: 0, onClick: (e) => e.stopPropagation(), onKeyDown: (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        } }, react_1.default.createElement(table_styles_1.ContextMenuSwitchWrapper, null, t({ key: 'MAP_TO_STRATEGY' }), react_1.default.createElement(ui_components_1.Switch, { checked: isMapped, onChange: handleMappingChange, disabled: isReEnrichmentInProgress })), react_1.default.createElement(table_styles_1.ContextMenuLink, { to: getMatrixUrl(), target: "_blank", rel: "noopener noreferrer", onClick: onClose }, t({ key: 'SHOW_PRODUCTS' }))));
};
exports.AttributeMappingMenu = AttributeMappingMenu;
